import type { TooltipProps } from "@mui/material";
import { Tooltip } from "@mui/material";
import React from "react";

interface DescriptiveTooltipProps extends Omit<
  TooltipProps,
  "title" | "disableInteractive"
> {
  title: React.ReactNode;
  children: React.ReactElement;
}

const DescriptiveTooltip: React.FC<DescriptiveTooltipProps> = ({
  title,
  children,
  ...rest
}) => (
  <Tooltip title={title} disableInteractive describeChild {...rest}>
    {children}
  </Tooltip>
);

export default DescriptiveTooltip;
